import { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import { toast } from 'sonner';
import { createSavedListingSearch } from '@/lib/api';
import { BellRing } from 'lucide-react';

const FREQUENCIES = [
  { value: 'instant', label: 'Sofort (bei jedem neuen Treffer)' },
  { value: 'daily', label: 'Täglich' },
  { value: 'weekly', label: 'Wöchentlich' },
  { value: 'off', label: 'Keine E-Mail' },
];

export function SaveSearchDialog({ open, onOpenChange, vertical, criteria, onSaved }) {
  const [name, setName] = useState('');
  const [frequency, setFrequency] = useState('daily');
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    if (!name.trim()) {
      toast.error('Bitte einen Namen angeben');
      return;
    }
    setSaving(true);
    try {
      const { data } = await createSavedListingSearch({ name: name.trim(), vertical, frequency, criteria });
      toast.success('Suche gespeichert');
      onSaved?.(data);
      onOpenChange(false);
      setName('');
      setFrequency('daily');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen');
    } finally {
      setSaving(false);
    }
  }

  const activeCount = Object.values(criteria || {}).filter((v) => v !== '' && v != null).length;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="save-search-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <BellRing className="w-5 h-5 text-orange-500" />
            Suche speichern
          </DialogTitle>
          <DialogDescription>
            Wir senden Ihnen E-Mails bei neuen passenden Inseraten.
            {activeCount > 0 ? (
              <span className="block mt-1 text-xs">
                {activeCount} aktive Filter werden gespeichert.
              </span>
            ) : null}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div>
            <Label htmlFor="ss-name">Name der Suche</Label>
            <Input
              id="ss-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="z.B. Heidelberg Druckwerk DE"
              data-testid="save-search-name"
            />
          </div>
          <div>
            <Label>Benachrichtigung</Label>
            <Select value={frequency} onValueChange={setFrequency}>
              <SelectTrigger data-testid="save-search-frequency"><SelectValue /></SelectTrigger>
              <SelectContent>
                {FREQUENCIES.map((f) => (
                  <SelectItem key={f.value} value={f.value}>{f.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Abbrechen</Button>
          <Button onClick={handleSave} disabled={saving} data-testid="save-search-confirm">
            {saving ? 'Speichere…' : 'Speichern'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
